import React from 'react'
import { Button } from '@/components/buttons/Button'

export default React.memo((props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      width: '100%',
      gap: '0.5rem',
      padding: '0.5rem',
      backgroundColor: 'var(--color-background-strong)',
      borderBottom: '1px solid var(--color-border)',
    }}
  >
    <input
      type="text"
      value={props.urlInputValue}
      placeholder="Enter URL"
      onChange={props.updateUrlValue}
    />
    <Button data-testid="url-submit" onClick={props.handleSubmit} size="tiny" primary>
      Confirm
    </Button>
    <Button
      onClick={(e) => {
        e.preventDefault()
        props.resetUrlInput()
      }}
      size="tiny"
    >
      Cancel
    </Button>
  </div>
))
